import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { useGetUser } from '../../queries/users';
import { ClerkRolesEnum } from '../../providers/ClerkProvider/types/clerk-roles.enum';
import { ProfileSettings } from './ProfileSettings';
import { headerTabsOptions } from './headerTabsOptions';
import { AppBar, Toolbar } from 'components/common';
import { HeaderMenu } from './HeaderMenu';
import { PageURL } from 'router/pageURL';
import logo from 'images/StrideUp_Logo_RGB_Neg.png';
import { PermissionType } from 'enums/permissionType.enum';
import { IHeaderMenuItem } from './types';
import { useAuth } from 'providers';

const filterHeaderTabsToRender = (userAccessGroups: PermissionType[], clerkRole?: string | null) => {
  return headerTabsOptions.filter(
    ({ permissions, textId }) =>
      permissions?.some((permission: PermissionType) => {
        return userAccessGroups.includes(permission);
      }) ||
      (textId === 'menu.organisation' && clerkRole === ClerkRolesEnum.Admin),
  );
};

export const AppHeader = () => {
  const { isSignedIn, orgRole } = useAuth();
  const { data: user } = useGetUser();

  const userAccessGroups: PermissionType[] = user?.roles.map(r => r.role.type) ?? [];

  const isProfileSettingsDisplayed = isSignedIn;

  const headerTabsToRender = filterHeaderTabsToRender(userAccessGroups, orgRole);

  return (
    <AppHeaderBody isProfileSettingsDisplayed={isProfileSettingsDisplayed} headerTabsToRender={headerTabsToRender} />
  );
};

type AppHeaderBodyProps = {
  headerTabsToRender: IHeaderMenuItem[];
  isProfileSettingsDisplayed?: boolean;
};

const AppHeaderBody = ({ headerTabsToRender, isProfileSettingsDisplayed }: AppHeaderBodyProps) => {
  return (
    <AppBar>
      <Toolbar sx={{ pr: '24px' }}>
        <Link to={PageURL.ROOT} className={'text-white no-underline'}>
          <img src={logo} alt='Strideup logo' className={'w-16'} />
        </Link>
        <div className={'flex w-full items-center px-1 pl-6'}>
          {headerTabsToRender.map(({ textId, menuOptions, link = '' }) => {
            const contentToRender = menuOptions ? (
              <HeaderMenu textId={textId} menuOptions={menuOptions} />
            ) : (
              <Link to={link} className={'block py-1.5 px-2 text-sm uppercase text-white no-underline'}>
                <FormattedMessage id={textId} />
              </Link>
            );

            return (
              <div key={textId} className={'my-0'}>
                {contentToRender}
              </div>
            );
          })}
        </div>
        {isProfileSettingsDisplayed && <ProfileSettings />}
      </Toolbar>
    </AppBar>
  );
};
